import angular from 'angular'

import { isArray, isString } from 'lodash-es'

import setCss from '../utils/set-css'

angular
  .module('ggs.background-image')
  .directive('ggsBackgroundImage', BackgroundImageProvider)

const URL_PREFIX = 'url("'
const URL_SUFFIX = '")'

function fmtUrls(image) {
  if (isArray(image)) {
    const filtered = image.filter(isString)
    return filtered.length !== 0
      ? filtered.map(fmtUrls).join(', ')
      : null
  } else if (isString(image)) {
    return URL_PREFIX + image + URL_SUFFIX
  } else {
    return null
  }
}

function BackgroundImageProvider($parse) {
  return {
    restrict: 'A',
    link($scope, $elm, $attr) {
      const ngExp = $parse($attr.ggsBackgroundImage)
      const image = ngExp($scope)
      const urls = fmtUrls(image)
      setCss($elm, 'background-image', urls)

      if (!ngExp.oneTime) {
        $scope.$watch(ngExp, (newVal) => {
          const urls = fmtUrls(newVal)
          setCss($elm, 'background-image', urls)
        })
      }
    }
  }
}
